import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { scrollToSection } from "@/lib/scrollToSection";

// Søren types himself an introduction the moment the hero loads. On wide screens
// the bubble is pinned beside the emblem with its tail pointing back at him, so
// the words read as his; narrower screens drop it under the ring. Tapping it
// jumps to his section.
const LINES = ["Hi, I'm Søren", "The bot inside BotChain CP. Ask me the basics, any hour.", "See what I can do"];
const GRADIENT_FROM = "Hi, I'm ".length; // his name gets the gradient treatment
const SPEED = 16;        // ms per character — fast, like someone firing off a text
const START_DELAY = 300;

function useTypewriter(total) {
  const still = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const [n, setN] = useState(still ? total : 0);
  useEffect(() => {
    if (n >= total) return;
    const t = setTimeout(() => setN(n + 1), n === 0 ? START_DELAY : SPEED);
    return () => clearTimeout(t);
  }, [n, total]);
  return n;
}

const Line = ({ text, children, className = "" }) => (
  <span className={`greet-line ${className}`}>
    <span className="greet-ghost" aria-hidden="true">{text}</span>
    <span className="greet-live">{children}</span>
  </span>
);

export const SorenHello = () => {
  const total = LINES.reduce((a, l) => a + l.length, 0);
  const n = useTypewriter(total);

  // How much of each line has been typed, and which line the caret sits on.
  const typed = (i) => {
    const before = LINES.slice(0, i).reduce((a, l) => a + l.length, 0);
    return Math.max(0, Math.min(LINES[i].length, n - before));
  };
  const cursorOn = LINES.findIndex((l, i) => typed(i) < l.length);
  const caret = (i) => (i === cursorOn ? <i className="greet-caret" /> : null);
  const g = typed(0);

  return (
    <button
      type="button"
      className="greet-bubble"
      onClick={() => scrollToSection("soren")}
      data-testid="hero-greet-bubble"
      aria-label="Hi, I'm Søren — see what I can do"
    >
      <Line text={LINES[0]} className="greet-bubble-greet">
        {LINES[0].slice(0, Math.min(g, GRADIENT_FROM))}
        {g > GRADIENT_FROM && <span className="gradient-text">{LINES[0].slice(GRADIENT_FROM, g)}</span>}
        {caret(0)}
      </Line>
      <Line text={LINES[1]} className="greet-bubble-sub text-ink-2">
        {LINES[1].slice(0, typed(1))}{caret(1)}
      </Line>
      <Line text={LINES[2]} className="greet-bubble-cta">
        {LINES[2].slice(0, typed(2))}
        {caret(2)}
        {typed(2) === LINES[2].length && <ChevronDown size={13} className="greet-cta-chev" />}
      </Line>
    </button>
  );
};

export default SorenHello;
